(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(61878);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19265);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67421);

// Custom



var Index = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        className: "min-h-screen py-10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "relative text-center py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container mx-auto px-6",
                    "data-aos": "fade-up",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "text-gray-800 dark:text-gray-200 text-4xl md:text-6xl font-bold",
                            children: [
                                t("Easier"),
                                " – ",
                                t("tower_management_made_simple_key")
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-4 text-lg md:text-xl text-gray-600 dark:text-gray-400",
                            children: t("hero_description_key")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/dashboard",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "mt-6 px-6 py-3 bg-hoverPrimary text-white rounded-lg shadow-lg text-lg font-semibold transition-all hover:bg-primary",
                                "data-aos": "zoom-in",
                                children: t("get_started_key")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "py-16 px-6 md:px-12 bg-gray-100 dark:bg-gray-800",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-5xl mx-auto text-center",
                        "data-aos": "fade-up",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-3xl font-bold text-gray-800 dark:text-gray-200",
                                children: t("key_features_key")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-600 dark:text-gray-400 mt-2",
                                children: t("features_description_key")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-w-5xl mx-auto",
                        children: [
                            {
                                title: t("feature1_title_key"),
                                icon: "\uD83D\uDDA5️",
                                text: t("feature1_description_key")
                            },
                            {
                                title: t("feature2_title_key"),
                                icon: "\uD83D\uDD14",
                                text: t("feature2_description_key")
                            },
                            {
                                title: t("feature3_title_key"),
                                icon: "\uD83D\uDCF1",
                                text: t("feature3_description_key")
                            }, 
                        ].map(function(feature, idx) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "p-6 text-center border rounded-lg shadow-sm hover:shadow-md transition-all bg-white dark:bg-gray-900 dark:border-gray-700",
                                "data-aos": "fade-up",
                                "data-aos-delay": idx * 200,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-5xl",
                                        children: feature.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "mt-4 text-xl font-semibold text-gray-800 dark:text-gray-200",
                                        children: feature.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-2 text-gray-600 dark:text-gray-400",
                                        children: feature.text
                                    })
                                ]
                            }, idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "py-16 px-6 md:px-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-5xl mx-auto text-center",
                        "data-aos": "fade-up",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-3xl font-bold text-gray-800 dark:text-gray-200",
                                children: t("how_it_works_key")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-600 dark:text-gray-400 mt-2",
                                children: t("how_it_works_description_key")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-w-5xl mx-auto",
                        children: [
                            {
                                title: t("step1_title_key"),
                                icon: "\uD83D\uDCDD",
                                text: t("step1_description_key")
                            },
                            {
                                title: t("step2_title_key"),
                                icon: "\uD83D\uDCB0",
                                text: t("step2_description_key")
                            },
                            {
                                title: t("step3_title_key"),
                                icon: "\uD83D\uDCCA",
                                text: t("step3_description_key")
                            }, 
                        ].map(function(step, idx) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "p-6 text-center border rounded-lg shadow-sm hover:shadow-md transition-all bg-gray-50 dark:bg-gray-800 dark:border-gray-700",
                                "data-aos": "fade-up",
                                "data-aos-delay": idx * 200,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-5xl",
                                        children: step.icon
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "mt-4 text-xl font-semibold text-gray-800 dark:text-gray-200",
                                        children: step.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-2 text-gray-600 dark:text-gray-400",
                                        children: step.text
                                    })
                                ]
                            }, idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "py-16 px-6 md:px-12 bg-gray-100 dark:bg-gray-800",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-5xl mx-auto text-center",
                        "data-aos": "fade-up",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-3xl font-bold text-gray-800 dark:text-gray-200",
                                children: t("pricing_title_key")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-600 dark:text-gray-400 mt-2",
                                children: t("pricing_description_key")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-w-5xl mx-auto",
                        children: [
                            {
                                title: t("pricing_basic_key"),
                                price: t("pricing_basic_price_key"),
                                features: [
                                    t("pricing_basic_feature1_key"),
                                    t("pricing_basic_feature2_key"),
                                    t("pricing_basic_feature3_key")
                                ]
                            },
                            {
                                title: t("pricing_pro_key"),
                                price: t("pricing_pro_price_key"),
                                features: [
                                    t("pricing_pro_feature1_key"),
                                    t("pricing_pro_feature2_key"),
                                    t("pricing_pro_feature3_key")
                                ]
                            },
                            {
                                title: t("pricing_enterprise_key"),
                                price: t("pricing_enterprise_price_key"),
                                features: [
                                    t("pricing_enterprise_feature1_key"),
                                    t("pricing_enterprise_feature2_key"),
                                    t("pricing_enterprise_feature3_key")
                                ]
                            }
                        ].map(function(plan, idx) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "p-6 text-center border rounded-lg shadow-sm hover:shadow-md transition-all bg-white dark:bg-gray-900 dark:border-gray-700",
                                "data-aos": "zoom-in",
                                "data-aos-delay": idx * 200,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-xl font-semibold text-gray-800 dark:text-gray-200",
                                        children: plan.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-2 text-2xl font-bold text-primary",
                                        children: plan.price
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "mt-4 text-gray-600 dark:text-gray-400",
                                        children: plan.features.map(function(feature, i) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                children: [
                                                    "✔ ",
                                                    feature
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            }, idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "text-center py-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-3xl md:text-4xl font-bold text-gray-800 dark:text-gray-200",
                        "data-aos": "fade-up",
                        children: t("contact_us_key")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-4 text-lg text-gray-600 dark:text-gray-400",
                        "data-aos": "fade-up",
                        "data-aos-delay": "200",
                        children: t("contact_description_key")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/contact",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "mt-6 px-6 py-3 bg-hoverPrimary text-white rounded-lg shadow-lg text-lg font-semibold transition-all hover:bg-primary",
                            "data-aos": "zoom-in",
                            children: t("contact_button_key")
                        })
                    })
                ]
            })
        ]
    });
};
Index.getLayout = function PageLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_1__/* .LandingPageLayout */ .U8, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [838,365,188,265,774,888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);